export default {"src":"/_next/static/media/effect-wing.678d99d9.svg","height":55,"width":439,"blurWidth":0,"blurHeight":0};